import graphql from 'babel-plugin-relay/macro';

export const PROFILE_SCORE_SCORE_DID_CHANGE_SUBSCRIPTION = graphql`
  subscription ProfileSubscriptionsProfileScoreDidChangeSubscription($pid: ID!, $skip: Boolean!) {
    profileScoreDidChange(pid: $pid) @skip(if: $skip) {
      ...ProfileFragmentsScoreSubscription
    }
  }
`;
